export const PUBLIC_SEO_LANDING_PAGES = {
  fishingApp: {
    path: "/fishing-app",
    navLabelKey: "public_seo.pages.fishingApp.navLabel",
    eyebrowKey: "public_seo.pages.fishingApp.eyebrow",
    headlineKey: "public_seo.pages.fishingApp.headline",
    introKey: "public_seo.pages.fishingApp.intro",
    features: [
      {
        titleKey: "public_seo.pages.fishingApp.features.log.title",
        bodyKey: "public_seo.pages.fishingApp.features.log.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.features.plan.title",
        bodyKey: "public_seo.pages.fishingApp.features.plan.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.features.community.title",
        bodyKey: "public_seo.pages.fishingApp.features.community.body",
      },
    ],
    sectionsTitleKey: "public_seo.pages.fishingApp.sectionsTitle",
    sections: [
      {
        titleKey: "public_seo.pages.fishingApp.sections.why.title",
        bodyKey: "public_seo.pages.fishingApp.sections.why.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.sections.catchLog.title",
        bodyKey: "public_seo.pages.fishingApp.sections.catchLog.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.sections.tripPlanner.title",
        bodyKey: "public_seo.pages.fishingApp.sections.tripPlanner.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.sections.spots.title",
        bodyKey: "public_seo.pages.fishingApp.sections.spots.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.sections.species.title",
        bodyKey: "public_seo.pages.fishingApp.sections.species.body",
      },
      {
        titleKey: "public_seo.pages.fishingApp.sections.conditions.title",
        bodyKey: "public_seo.pages.fishingApp.sections.conditions.body",
      },
    ],
    helpTitleKey: "public_seo.pages.fishingApp.helpTitle",
    helpItemKeys: [
      "public_seo.pages.fishingApp.helpItems.free",
      "public_seo.pages.fishingApp.helpItems.android",
      "public_seo.pages.fishingApp.helpItems.connected",
    ],
    links: [
      {
        to: "/fishing-catch-log-app/",
        labelKey: "public_seo.pages.fishingApp.links.catchLog.label",
        descriptionKey: "public_seo.pages.fishingApp.links.catchLog.description",
      },
      {
        to: "/fishing-spots-app/",
        labelKey: "public_seo.pages.fishingApp.links.spots.label",
        descriptionKey: "public_seo.pages.fishingApp.links.spots.description",
      },
      {
        to: "/fishing-trip-planner/",
        labelKey: "public_seo.pages.fishingApp.links.tripPlanner.label",
        descriptionKey: "public_seo.pages.fishingApp.links.tripPlanner.description",
      },
      {
        to: "/fish-species-guide/",
        labelKey: "public_seo.pages.fishingApp.links.speciesGuide.label",
        descriptionKey: "public_seo.pages.fishingApp.links.speciesGuide.description",
      },
      {
        to: "/fishing-regulations/",
        labelKey: "public_seo.pages.fishingApp.links.regulations.label",
        descriptionKey: "public_seo.pages.fishingApp.links.regulations.description",
      },
      {
        to: "/fishipedia",
        labelKey: "public_seo.pages.fishingApp.links.fishipedia.label",
        descriptionKey: "public_seo.pages.fishingApp.links.fishipedia.description",
      },
      {
        to: "/register",
        labelKey: "public_seo.pages.fishingApp.links.register.label",
        descriptionKey: "public_seo.pages.fishingApp.links.register.description",
      },
      {
        to: "/login",
        labelKey: "public_seo.pages.fishingApp.links.login.label",
        descriptionKey: "public_seo.pages.fishingApp.links.login.description",
      },
    ],
    faqTitleKey: "public_seo.pages.fishingApp.faqTitle",
    faqs: [
      {
        questionKey: "public_seo.pages.fishingApp.faqs.what.question",
        answerKey: "public_seo.pages.fishingApp.faqs.what.answer",
      },
      {
        questionKey: "public_seo.pages.fishingApp.faqs.free.question",
        answerKey: "public_seo.pages.fishingApp.faqs.free.answer",
      },
      {
        questionKey: "public_seo.pages.fishingApp.faqs.android.question",
        answerKey: "public_seo.pages.fishingApp.faqs.android.answer",
      },
      {
        questionKey: "public_seo.pages.fishingApp.faqs.catchLog.question",
        answerKey: "public_seo.pages.fishingApp.faqs.catchLog.answer",
      },
      {
        questionKey: "public_seo.pages.fishingApp.faqs.planning.question",
        answerKey: "public_seo.pages.fishingApp.faqs.planning.answer",
      },
    ],
    ctaKey: "public_seo.pages.fishingApp.cta",
  },
  fishingCatchLogApp: {
    path: "/fishing-catch-log-app",
    navLabelKey: "public_seo.pages.fishingCatchLogApp.navLabel",
    eyebrowKey: "public_seo.pages.fishingCatchLogApp.eyebrow",
    headlineKey: "public_seo.pages.fishingCatchLogApp.headline",
    introKey: "public_seo.pages.fishingCatchLogApp.intro",
    features: [
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.features.photos.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.features.photos.body",
      },
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.features.details.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.features.details.body",
      },
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.features.history.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.features.history.body",
      },
    ],
    sectionsTitleKey: "public_seo.pages.fishingCatchLogApp.sectionsTitle",
    sections: [
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.sections.what.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.sections.what.body",
      },
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.sections.record.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.sections.record.body",
      },
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.sections.learn.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.sections.learn.body",
      },
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.sections.memories.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.sections.memories.body",
      },
      {
        titleKey: "public_seo.pages.fishingCatchLogApp.sections.connect.title",
        bodyKey: "public_seo.pages.fishingCatchLogApp.sections.connect.body",
      },
    ],
    helpTitleKey: "public_seo.pages.fishingCatchLogApp.helpTitle",
    helpItemKeys: [
      "public_seo.pages.fishingCatchLogApp.helpItems.records",
      "public_seo.pages.fishingCatchLogApp.helpItems.patterns",
      "public_seo.pages.fishingCatchLogApp.helpItems.profile",
    ],
    links: [
      {
        to: "/fishing-app/",
        labelKey: "public_seo.pages.fishingCatchLogApp.links.fishingApp.label",
        descriptionKey: "public_seo.pages.fishingCatchLogApp.links.fishingApp.description",
      },
      {
        to: "/fishing-trip-planner/",
        labelKey: "public_seo.pages.fishingCatchLogApp.links.tripPlanner.label",
        descriptionKey: "public_seo.pages.fishingCatchLogApp.links.tripPlanner.description",
      },
      {
        to: "/fish-species-guide/",
        labelKey: "public_seo.pages.fishingCatchLogApp.links.speciesGuide.label",
        descriptionKey: "public_seo.pages.fishingCatchLogApp.links.speciesGuide.description",
      },
      {
        to: "/fishing-spots-app/",
        labelKey: "public_seo.pages.fishingCatchLogApp.links.spots.label",
        descriptionKey: "public_seo.pages.fishingCatchLogApp.links.spots.description",
      },
      {
        to: "/register",
        labelKey: "public_seo.pages.fishingCatchLogApp.links.register.label",
        descriptionKey: "public_seo.pages.fishingCatchLogApp.links.register.description",
      },
      {
        to: "/login",
        labelKey: "public_seo.pages.fishingCatchLogApp.links.login.label",
        descriptionKey: "public_seo.pages.fishingCatchLogApp.links.login.description",
      },
    ],
    faqTitleKey: "public_seo.pages.fishingCatchLogApp.faqTitle",
    faqs: [
      {
        questionKey: "public_seo.pages.fishingCatchLogApp.faqs.what.question",
        answerKey: "public_seo.pages.fishingCatchLogApp.faqs.what.answer",
      },
      {
        questionKey: "public_seo.pages.fishingCatchLogApp.faqs.reelitpro.question",
        answerKey: "public_seo.pages.fishingCatchLogApp.faqs.reelitpro.answer",
      },
      {
        questionKey: "public_seo.pages.fishingCatchLogApp.faqs.details.question",
        answerKey: "public_seo.pages.fishingCatchLogApp.faqs.details.answer",
      },
      {
        questionKey: "public_seo.pages.fishingCatchLogApp.faqs.improve.question",
        answerKey: "public_seo.pages.fishingCatchLogApp.faqs.improve.answer",
      },
      {
        questionKey: "public_seo.pages.fishingCatchLogApp.faqs.journal.question",
        answerKey: "public_seo.pages.fishingCatchLogApp.faqs.journal.answer",
      },
    ],
    ctaKey: "public_seo.pages.fishingCatchLogApp.cta",
  },
  fishingSpotsApp: {
    path: "/fishing-spots-app",
    navLabelKey: "public_seo.pages.fishingSpotsApp.navLabel",
    eyebrowKey: "public_seo.pages.fishingSpotsApp.eyebrow",
    headlineKey: "public_seo.pages.fishingSpotsApp.headline",
    introKey: "public_seo.pages.fishingSpotsApp.intro",
    features: [
      {
        titleKey: "public_seo.pages.fishingSpotsApp.features.map.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.features.map.body",
      },
      {
        titleKey: "public_seo.pages.fishingSpotsApp.features.prepare.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.features.prepare.body",
      },
      {
        titleKey: "public_seo.pages.fishingSpotsApp.features.context.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.features.context.body",
      },
    ],
    sectionsTitleKey: "public_seo.pages.fishingSpotsApp.sectionsTitle",
    sections: [
      {
        titleKey: "public_seo.pages.fishingSpotsApp.sections.explore.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.sections.explore.body",
      },
      {
        titleKey: "public_seo.pages.fishingSpotsApp.sections.maps.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.sections.maps.body",
      },
      {
        titleKey: "public_seo.pages.fishingSpotsApp.sections.prepare.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.sections.prepare.body",
      },
      {
        titleKey: "public_seo.pages.fishingSpotsApp.sections.connect.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.sections.connect.body",
      },
      {
        titleKey: "public_seo.pages.fishingSpotsApp.sections.waterTypes.title",
        bodyKey: "public_seo.pages.fishingSpotsApp.sections.waterTypes.body",
      },
    ],
    helpTitleKey: "public_seo.pages.fishingSpotsApp.helpTitle",
    helpItemKeys: [
      "public_seo.pages.fishingSpotsApp.helpItems.map",
      "public_seo.pages.fishingSpotsApp.helpItems.private",
      "public_seo.pages.fishingSpotsApp.helpItems.connected",
    ],
    links: [
      {
        to: "/fishing-app/",
        labelKey: "public_seo.pages.fishingSpotsApp.links.fishingApp.label",
        descriptionKey: "public_seo.pages.fishingSpotsApp.links.fishingApp.description",
      },
      {
        to: "/fishing-catch-log-app/",
        labelKey: "public_seo.pages.fishingSpotsApp.links.catchLog.label",
        descriptionKey: "public_seo.pages.fishingSpotsApp.links.catchLog.description",
      },
      {
        to: "/fishing-trip-planner/",
        labelKey: "public_seo.pages.fishingSpotsApp.links.tripPlanner.label",
        descriptionKey: "public_seo.pages.fishingSpotsApp.links.tripPlanner.description",
      },
      {
        to: "/fish-species-guide/",
        labelKey: "public_seo.pages.fishingSpotsApp.links.speciesGuide.label",
        descriptionKey: "public_seo.pages.fishingSpotsApp.links.speciesGuide.description",
      },
      {
        to: "/fishing-regulations/",
        labelKey: "public_seo.pages.fishingSpotsApp.links.regulations.label",
        descriptionKey: "public_seo.pages.fishingSpotsApp.links.regulations.description",
      },
      {
        to: "/register",
        labelKey: "public_seo.pages.fishingSpotsApp.links.register.label",
        descriptionKey: "public_seo.pages.fishingSpotsApp.links.register.description",
      },
    ],
    faqTitleKey: "public_seo.pages.fishingSpotsApp.faqTitle",
    faqs: [
      {
        questionKey: "public_seo.pages.fishingSpotsApp.faqs.what.question",
        answerKey: "public_seo.pages.fishingSpotsApp.faqs.what.answer",
      },
      {
        questionKey: "public_seo.pages.fishingSpotsApp.faqs.explore.question",
        answerKey: "public_seo.pages.fishingSpotsApp.faqs.explore.answer",
      },
      {
        questionKey: "public_seo.pages.fishingSpotsApp.faqs.maps.question",
        answerKey: "public_seo.pages.fishingSpotsApp.faqs.maps.answer",
      },
      {
        questionKey: "public_seo.pages.fishingSpotsApp.faqs.locations.question",
        answerKey: "public_seo.pages.fishingSpotsApp.faqs.locations.answer",
      },
      {
        questionKey: "public_seo.pages.fishingSpotsApp.faqs.waterTypes.question",
        answerKey: "public_seo.pages.fishingSpotsApp.faqs.waterTypes.answer",
      },
    ],
    ctaKey: "public_seo.pages.fishingSpotsApp.cta",
  },
  fishingTripPlanner: {
    path: "/fishing-trip-planner",
    navLabelKey: "public_seo.pages.fishingTripPlanner.navLabel",
    eyebrowKey: "public_seo.pages.fishingTripPlanner.eyebrow",
    headlineKey: "public_seo.pages.fishingTripPlanner.headline",
    introKey: "public_seo.pages.fishingTripPlanner.intro",
    features: [
      {
        titleKey: "public_seo.pages.fishingTripPlanner.features.prepare.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.features.prepare.body",
      },
      {
        titleKey: "public_seo.pages.fishingTripPlanner.features.checklist.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.features.checklist.body",
      },
      {
        titleKey: "public_seo.pages.fishingTripPlanner.features.review.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.features.review.body",
      },
    ],
    sectionsTitleKey: "public_seo.pages.fishingTripPlanner.sectionsTitle",
    sections: [
      {
        titleKey: "public_seo.pages.fishingTripPlanner.sections.before.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.sections.before.body",
      },
      {
        titleKey: "public_seo.pages.fishingTripPlanner.sections.species.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.sections.species.body",
      },
      {
        titleKey: "public_seo.pages.fishingTripPlanner.sections.checklists.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.sections.checklists.body",
      },
      {
        titleKey: "public_seo.pages.fishingTripPlanner.sections.conditions.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.sections.conditions.body",
      },
      {
        titleKey: "public_seo.pages.fishingTripPlanner.sections.after.title",
        bodyKey: "public_seo.pages.fishingTripPlanner.sections.after.body",
      },
    ],
    helpTitleKey: "public_seo.pages.fishingTripPlanner.helpTitle",
    helpItemKeys: [
      "public_seo.pages.fishingTripPlanner.helpItems.details",
      "public_seo.pages.fishingTripPlanner.helpItems.catchLogging",
      "public_seo.pages.fishingTripPlanner.helpItems.research",
    ],
    links: [
      {
        to: "/fishing-app/",
        labelKey: "public_seo.pages.fishingTripPlanner.links.fishingApp.label",
        descriptionKey: "public_seo.pages.fishingTripPlanner.links.fishingApp.description",
      },
      {
        to: "/fishing-catch-log-app/",
        labelKey: "public_seo.pages.fishingTripPlanner.links.catchLog.label",
        descriptionKey: "public_seo.pages.fishingTripPlanner.links.catchLog.description",
      },
      {
        to: "/fishing-spots-app/",
        labelKey: "public_seo.pages.fishingTripPlanner.links.spots.label",
        descriptionKey: "public_seo.pages.fishingTripPlanner.links.spots.description",
      },
      {
        to: "/fish-species-guide/",
        labelKey: "public_seo.pages.fishingTripPlanner.links.speciesGuide.label",
        descriptionKey: "public_seo.pages.fishingTripPlanner.links.speciesGuide.description",
      },
      {
        to: "/fishing-regulations/",
        labelKey: "public_seo.pages.fishingTripPlanner.links.regulations.label",
        descriptionKey: "public_seo.pages.fishingTripPlanner.links.regulations.description",
      },
      {
        to: "/register",
        labelKey: "public_seo.pages.fishingTripPlanner.links.register.label",
        descriptionKey: "public_seo.pages.fishingTripPlanner.links.register.description",
      },
    ],
    faqTitleKey: "public_seo.pages.fishingTripPlanner.faqTitle",
    faqs: [
      {
        questionKey: "public_seo.pages.fishingTripPlanner.faqs.what.question",
        answerKey: "public_seo.pages.fishingTripPlanner.faqs.what.answer",
      },
      {
        questionKey: "public_seo.pages.fishingTripPlanner.faqs.reelitpro.question",
        answerKey: "public_seo.pages.fishingTripPlanner.faqs.reelitpro.answer",
      },
      {
        questionKey: "public_seo.pages.fishingTripPlanner.faqs.checklists.question",
        answerKey: "public_seo.pages.fishingTripPlanner.faqs.checklists.answer",
      },
      {
        questionKey: "public_seo.pages.fishingTripPlanner.faqs.beforeAfter.question",
        answerKey: "public_seo.pages.fishingTripPlanner.faqs.beforeAfter.answer",
      },
      {
        questionKey: "public_seo.pages.fishingTripPlanner.faqs.catchLogging.question",
        answerKey: "public_seo.pages.fishingTripPlanner.faqs.catchLogging.answer",
      },
    ],
    ctaKey: "public_seo.pages.fishingTripPlanner.cta",
  },
  fishSpeciesGuide: {
    path: "/fish-species-guide",
    navLabelKey: "public_seo.pages.fishSpeciesGuide.navLabel",
    eyebrowKey: "public_seo.pages.fishSpeciesGuide.eyebrow",
    headlineKey: "public_seo.pages.fishSpeciesGuide.headline",
    introKey: "public_seo.pages.fishSpeciesGuide.intro",
    features: [
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.features.research.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.features.research.body",
      },
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.features.waterTypes.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.features.waterTypes.body",
      },
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.features.connect.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.features.connect.body",
      },
    ],
    sectionsTitleKey: "public_seo.pages.fishSpeciesGuide.sectionsTitle",
    sections: [
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.sections.learn.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.sections.learn.body",
      },
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.sections.freshwater.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.sections.freshwater.body",
      },
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.sections.info.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.sections.info.body",
      },
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.sections.connect.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.sections.connect.body",
      },
      {
        titleKey: "public_seo.pages.fishSpeciesGuide.sections.fishipedia.title",
        bodyKey: "public_seo.pages.fishSpeciesGuide.sections.fishipedia.body",
      },
    ],
    helpTitleKey: "public_seo.pages.fishSpeciesGuide.helpTitle",
    helpItemKeys: [
      "public_seo.pages.fishSpeciesGuide.helpItems.research",
      "public_seo.pages.fishSpeciesGuide.helpItems.compare",
      "public_seo.pages.fishSpeciesGuide.helpItems.account",
    ],
    links: [
      {
        to: "/fishipedia",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.fishipedia.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.fishipedia.description",
      },
      {
        to: "/fishing-app/",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.fishingApp.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.fishingApp.description",
      },
      {
        to: "/fishing-catch-log-app/",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.catchLog.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.catchLog.description",
      },
      {
        to: "/fishing-trip-planner/",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.tripPlanner.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.tripPlanner.description",
      },
      {
        to: "/fishing-spots-app/",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.spots.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.spots.description",
      },
      {
        to: "/fishing-regulations/",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.regulations.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.regulations.description",
      },
      {
        to: "/register",
        labelKey: "public_seo.pages.fishSpeciesGuide.links.register.label",
        descriptionKey: "public_seo.pages.fishSpeciesGuide.links.register.description",
      },
    ],
    faqTitleKey: "public_seo.pages.fishSpeciesGuide.faqTitle",
    faqs: [
      {
        questionKey: "public_seo.pages.fishSpeciesGuide.faqs.what.question",
        answerKey: "public_seo.pages.fishSpeciesGuide.faqs.what.answer",
      },
      {
        questionKey: "public_seo.pages.fishSpeciesGuide.faqs.fishipedia.question",
        answerKey: "public_seo.pages.fishSpeciesGuide.faqs.fishipedia.answer",
      },
      {
        questionKey: "public_seo.pages.fishSpeciesGuide.faqs.waterTypes.question",
        answerKey: "public_seo.pages.fishSpeciesGuide.faqs.waterTypes.answer",
      },
      {
        questionKey: "public_seo.pages.fishSpeciesGuide.faqs.tripPlanning.question",
        answerKey: "public_seo.pages.fishSpeciesGuide.faqs.tripPlanning.answer",
      },
      {
        questionKey: "public_seo.pages.fishSpeciesGuide.faqs.catchLogging.question",
        answerKey: "public_seo.pages.fishSpeciesGuide.faqs.catchLogging.answer",
      },
    ],
    ctaKey: "public_seo.pages.fishSpeciesGuide.cta",
  },
  fishingRegulations: {
    path: "/fishing-regulations",
    navLabelKey: "public_seo.pages.fishingRegulations.navLabel",
    eyebrowKey: "public_seo.pages.fishingRegulations.eyebrow",
    headlineKey: "public_seo.pages.fishingRegulations.headline",
    introKey: "public_seo.pages.fishingRegulations.intro",
    features: [
      {
        titleKey: "public_seo.pages.fishingRegulations.features.rules.title",
        bodyKey: "public_seo.pages.fishingRegulations.features.rules.body",
      },
      {
        titleKey: "public_seo.pages.fishingRegulations.features.licence.title",
        bodyKey: "public_seo.pages.fishingRegulations.features.licence.body",
      },
      {
        titleKey: "public_seo.pages.fishingRegulations.features.official.title",
        bodyKey: "public_seo.pages.fishingRegulations.features.official.body",
      },
    ],
    sectionsTitleKey: "public_seo.pages.fishingRegulations.sectionsTitle",
    sections: [
      {
        titleKey: "public_seo.pages.fishingRegulations.sections.check.title",
        bodyKey: "public_seo.pages.fishingRegulations.sections.check.body",
      },
      {
        titleKey: "public_seo.pages.fishingRegulations.sections.licences.title",
        bodyKey: "public_seo.pages.fishingRegulations.sections.licences.body",
      },
      {
        titleKey: "public_seo.pages.fishingRegulations.sections.local.title",
        bodyKey: "public_seo.pages.fishingRegulations.sections.local.body",
      },
      {
        titleKey: "public_seo.pages.fishingRegulations.sections.startingPoint.title",
        bodyKey: "public_seo.pages.fishingRegulations.sections.startingPoint.body",
      },
      {
        titleKey: "public_seo.pages.fishingRegulations.sections.verify.title",
        bodyKey: "public_seo.pages.fishingRegulations.sections.verify.body",
      },
    ],
    helpTitleKey: "public_seo.pages.fishingRegulations.helpTitle",
    helpItemKeys: [
      "public_seo.pages.fishingRegulations.helpItems.flow",
      "public_seo.pages.fishingRegulations.helpItems.local",
      "public_seo.pages.fishingRegulations.helpItems.verify",
    ],
    links: [
      {
        to: "/fishing-app/",
        labelKey: "public_seo.pages.fishingRegulations.links.fishingApp.label",
        descriptionKey: "public_seo.pages.fishingRegulations.links.fishingApp.description",
      },
      {
        to: "/fishing-trip-planner/",
        labelKey: "public_seo.pages.fishingRegulations.links.tripPlanner.label",
        descriptionKey: "public_seo.pages.fishingRegulations.links.tripPlanner.description",
      },
      {
        to: "/fish-species-guide/",
        labelKey: "public_seo.pages.fishingRegulations.links.speciesGuide.label",
        descriptionKey: "public_seo.pages.fishingRegulations.links.speciesGuide.description",
      },
      {
        to: "/fishing-spots-app/",
        labelKey: "public_seo.pages.fishingRegulations.links.spots.label",
        descriptionKey: "public_seo.pages.fishingRegulations.links.spots.description",
      },
      {
        to: "/regulations",
        labelKey: "public_seo.pages.fishingRegulations.links.regulations.label",
        descriptionKey: "public_seo.pages.fishingRegulations.links.regulations.description",
      },
      {
        to: "/register",
        labelKey: "public_seo.pages.fishingRegulations.links.register.label",
        descriptionKey: "public_seo.pages.fishingRegulations.links.register.description",
      },
    ],
    faqTitleKey: "public_seo.pages.fishingRegulations.faqTitle",
    faqs: [
      {
        questionKey: "public_seo.pages.fishingRegulations.faqs.why.question",
        answerKey: "public_seo.pages.fishingRegulations.faqs.why.answer",
      },
      {
        questionKey: "public_seo.pages.fishingRegulations.faqs.rules.question",
        answerKey: "public_seo.pages.fishingRegulations.faqs.rules.answer",
      },
      {
        questionKey: "public_seo.pages.fishingRegulations.faqs.location.question",
        answerKey: "public_seo.pages.fishingRegulations.faqs.location.answer",
      },
      {
        questionKey: "public_seo.pages.fishingRegulations.faqs.official.question",
        answerKey: "public_seo.pages.fishingRegulations.faqs.official.answer",
      },
      {
        questionKey: "public_seo.pages.fishingRegulations.faqs.waterTypes.question",
        answerKey: "public_seo.pages.fishingRegulations.faqs.waterTypes.answer",
      },
    ],
    ctaKey: "public_seo.pages.fishingRegulations.cta",
  },
};
